import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams, useLocation } from 'react-router-dom';
import LifeInvestmentService from '../../shared/services/LifeInvestmentService';
import PSPolicyOptions from '../../components/molecules/PSPolicyOptions/PSPolicyOptions';
import PSValueChart from '../../components/molecules/PSValueChart/PSValueChart';
import PSInvestmentTabs from '../../components/molecules/PSInvestmentTabs/PSInvestmentTabs';
import PSInvestmentPerformance from '../../components/molecules/PSInvestmentPerformance/PSInvestmentPerformance';
import PSIcon from '../../components/PSIcon';
import PSGlobalLoading from '../../components/PSGlobalLoading';

import './index.scss';

export default function PolicyDetail() {
  const { id } = useParams();
  const sessionPD = localStorage.getItem('sessionPD');
  const [isLoading, setIsLoading] = useState(false);

  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${today.getFullYear()}`;

  const policyDetail = JSON.parse(localStorage.getItem('policyDetail')) || null;
  const fundData = JSON.parse(localStorage.getItem('dataFund')) || null;
  // eslint-disable-next-line no-shadow
  const graphicalDataSets = useSelector((state) => state.auth.graphicalData);

  const dataQuoteEvolution = JSON.parse(localStorage.getItem('quoteEvolution')) || [];

  const goToPage = () => {
    window.history.back();
  };

  const getDataFund = async () => {
    setIsLoading(true);
    const lastDayPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    const year = lastDayPrevMonth.getFullYear();
    const month = String(lastDayPrevMonth.getMonth() + 1).padStart(2, '0');
    const day = String(lastDayPrevMonth.getDate()).padStart(2, '0');
    const dateFormatted = `${year}-${month}-${day}`;

    try {
      const payload = {
        nroPoliza: id
        // fechaCierre: dateFormatted,
      };
      const responseDataFund = await LifeInvestmentService.getDataFund(
        payload
      );
      
      localStorage.setItem('dataFund', JSON.stringify(responseDataFund));
      setIsLoading(false);
    } catch (error) {
      console.error('Error al obtener datos del fondo:', error);
      setIsLoading(false);
    }
  };

  const transformYear = (dateString) => {
    const fecha = dateString;
    const anio = fecha.split('/')[2];
    return anio;
  };

  useEffect(() => {
    if (!fundData) {
      getDataFund();
    }
  }, [sessionPD]);

  return (
    <>
      <div className="policy-detail__container">
        {isLoading && <PSGlobalLoading show={isLoading} />}
        <div className="policy-detail__container--header">
          <div className="breadcrumb">
            <Link to="/intranet" className="breadcrumb-link">
              <PSIcon type="homeGray" className="breadcrumb-icon" />
              <span>Mis seguros</span>
            </Link>
            <div className="breadcrumb-separator">
              <PSIcon type="arrowRightOrange" className="arrow" />
            </div>
            <div className="breadcrumb-link" onClick={() => goToPage()}>
              <span>Vida Inversión Global Protecta</span>
            </div>
            <div className="breadcrumb-separator">
              <PSIcon type="arrowRightOrange" className="arrow" />
            </div>
            <span className="breadcrumb-current">Ver más</span>
          </div>
          <h1>Vida Inversión Global Protecta</h1>
        </div>
        <div className="policy-detail__container--finance">
          <h4 className="finance-title">
            Desde que aperturó en {transformYear(policyDetail?.BasicInfo?.InicioVigencia)}
          </h4>

          <div className="finance-cards">
            <div className="card-container">
              <div className="card-icon">
                <PSIcon type="moneyBag" className="money-bag" />
              </div>
              <div className="card-info">
                <p className="card-label desktop">
                  Cuotas acumuladas <br /> al {formattedDate}:
                </p>
                <p className="card-label mobile">Cuotas acumuladas:</p>
                <p className="card-value">{fundData?.montoNroCuota ?? '-'}</p>
              </div>
            </div>
            <div className="finance-operation">X</div>
            <div className="card-container">
              <div className="card-icon desktop">
                <PSIcon type="trendingUp" />
              </div>
              <div className="card-icon mobile">
                <PSIcon type="operatorMultiplication" />
              </div>
              <div className="card-info">
                <p className="card-label desktop">
                  Valor cuota del fondo <br /> al {formattedDate}
                </p>
                <p className="card-label mobile">Valor cuota del fondo al {formattedDate}:</p>
                <p className="card-value">{fundData?.valorCuotaActual ?? '-'}</p>
              </div>
            </div>
            <div className="finance-operation">=</div>
            <div className="card-container container-secondary">
              <div className="card-icon desktop">
                <PSIcon type="moneyBag" />
              </div>
              <div className="card-icon mobile">
                <PSIcon type="operatorEqual" />
              </div>
              <div className="card-info">
                <p className="card-label">Fondo ahorrado:</p>
                <p className="card-value">{fundData?.montoPrimaEmitida ?? '-'}</p>
                <p className="card-extra">
                  en <span>Fondo Balanceado</span>
                </p>
              </div>
            </div>
          </div>
          <div className="finance-info">
            <div className="tooltip-container">
              <PSIcon type="alertFAD" className="container-icon" />
              <span className="tooltip-text">Información actualizada hasta {formattedDate}</span>
            </div>
            Todos los gastos de la póliza han sido deducidos de la cantidad de cuotas mostrada.
          </div>
        </div>
        {policyDetail && (
          <div className="policy-detail__container--options">
            <PSPolicyOptions dataPolicy={policyDetail} />
          </div>
        )}
        {graphicalDataSets && (
          <div className="policy-detail__container--investment">
            <PSInvestmentTabs dataSets={graphicalDataSets} />
          </div>
        )}
        {dataQuoteEvolution.length > 0 && (
          <div className="policy-detail__container--values">
            <PSValueChart data={dataQuoteEvolution} />
          </div>
        )}
        <div className="policy-detail__container--performance">
          <PSInvestmentPerformance />
        </div>
      </div>
    </>
  );
}
